<template>
  <button
    v-for="item in buttonList"
    style="margin-bottom: 20px;"
    @click="toHref(item.buttonUrl)"
  >{{ item.buttonName }}</button>
  <vue-advanced-chat
    :height="`calc(100vh - 300px)`"
    :single-room="true"
    :show-search="false"
    :show-add-room="false"
    :show-files="true"
    :show-audio="false"
    :show-emojis="false"
    :messages-loaded="messagesLoaded"
    :loading-rooms="true"
    :current-user-id="'1234'"
    :rooms="JSON.stringify(rooms)"
    :messages="JSON.stringify(messages)"
    accepted-files="video/wmv, video/avi, video/mp4, video/flv, application/pdf, image/jpeg, image/png, image/jpg"
    @send-message="sendMessage($event.detail[0])"
    @open-file="onOpenFile($event.detail[0])"
  />
  <!-- <input type="file" :capture="'environment'" accept="image/*" multiple > -->
  <input type="file" accept="image/*" :capture="true">
</template>
<script setup lang="ts">
import { register } from '@voghion/vue-advanced-chat/external'
// import { register } from '../../dist/vue-advanced-chat.es'
import { ref, onMounted } from 'vue';
import { useMsgStore } from '@/states/msg';
import { handleUploadFile } from '@/api/request';
import { v4 } from 'uuid'
register()

const msgStore = useMsgStore();
const title = ref('im-test');
const buttonList = ref([]);
const messagesLoaded = ref(false);

const rooms = ref([{
  roomId: '1',
  roomName: 'Room 1',
  avatar: 'assets/imgs/people.png',
  unreadCount: 4,
  index: 3,
  users: [
    {
      _id: '1234',
      username: 'John Doe',
      avatar: 'assets/imgs/doe.png',
      status: {
        state: 'online',
        lastChanged: 'today, 14:30'
      }
    },
    {
      _id: '4321',
      username: 'John Snow',
      avatar: 'assets/imgs/snow.png',
      status: {
        state: 'offline',
        lastChanged: '14 July, 20:00'
      }
    }
  ],
}]);
const messages = ref([]);

const toHref = (appUrl) => {
  const decodeUrl = decodeURIComponent(appUrl);
  const url = decodeUrl.split("openUrl=")[1];
  window.location.href = url;
}

const sendMessage = async (messageData) => {
  console.log('messageData', messageData);
  const { files } = messageData;
  console.log('files', files);
  const resultUploadDataList = await Promise.all(files.map(file => handleUploadFile(file)))
  console.log('resultUploadDataList', resultUploadDataList);
  const msgFiles = files.map((e, i) => ({
    name: e.name,
    size: e.size,
    type: e.extension,
    audio: true,
    preview: e.localUrl,
    url: resultUploadDataList[i].data,
    // localUrl: e.localUrl
    // duration: 1
    // progress: 100,
  }))
  const newMsg = { _id: v4(), ...messageData, files: msgFiles.map(e => ({ ...e, url: e.preview })), senderId: '1234' };
  messages.value.push(newMsg);
}

const onOpenFile = ({ message, file:fileObj }) => {
  console.log('message, file', message, fileObj);
  const { action, file } = fileObj;
  if (action === 'download') {
    window.open(file.url, '_blank');
  }
  // window.location.href = file.url
}


onMounted(() => {
  msgStore.getEndpoint().then(res => {
    console.log('res', res.data);
    if (Array.isArray(res.data.buttons)) {
      buttonList.value = res.data.buttons;
    }
  });
  messagesLoaded.value = true;
})

</script>